export default __webpack_public_path__ + "static/media/abstracto-3d.e9ea8cf3.svg";